import axios from 'axios';
import { getAccessToken } from "./apiTokenHandler";
import { useNavigate } from 'react-router-dom';
import { useUiState } from "helpers/useUiState";

import { useTranslation } from "react-i18next";
import { handleErrorNavigation } from 'pages/ErrorPage/ErrorHandler';
export const useApi = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { isAppLoading } = useUiState();
    const api = axios.create({
        baseURL: process.env.REACT_APP_API_ENDPOINT, // Replace with your API base URL
        headers: {
            'Content-Type': 'application/json',
        },
    });
    api.interceptors.request.use(
        (config) => {
            // Modify the request config here (e.g., add headers, authentication tokens)
            const accessToken = getAccessToken();

            // ** If token is present add it to request's Authorization Header
            if (accessToken) {
                if (config.headers) config.headers.Authorization = `Bearer ${accessToken}`;
            }
            else {
                if (config.headers) config.headers.Authorization = `Bearer ${null}`;
            }
            return config;
        },
        (error) => {
            // Handle request errors here

            return Promise.reject(error);
        }
    );

    // Response interceptor
    api.interceptors.response.use(
        (response) => {
            // Modify the response data here (e.g., parse, transform)
            let payload = {
                HTTP_STATUS: response.status,
                data: response.data
            }

            return payload;
        },
        (error) => {
            isAppLoading(false)
            if (error.status === 404) {
                handleErrorNavigation(error,navigate,t);
            }
            if (error.status === 500) {
                handleErrorNavigation(error,navigate,t);
            }
            return Promise.reject(error.response)
        }
    );

    return { api };
}
export default useApi;